import { createUseResponsiveValue } from '@hooks';

import * as BREAKPOINT from '@app/constants/breakpoint';

const useResponsiveValue = createUseResponsiveValue([
  BREAKPOINT.MOBILE,
  BREAKPOINT.TABLET,
  BREAKPOINT.DESKTOP,
]);

export default useResponsiveValue;
